export default "__VITE_ASSET__aTbSpl9Z__"